export const reducerTypes = {
  GET_ALL_MODELS: "reducer/GET_ALL_MODELS",
  GET_MORE_MODELS: "reducer/GET_MORE_MODELS",
  SET_PAGE_INFO: "reducer/SET_PAGE_INFO",
  SET_PAGE_INDEX: "reducer/SET_PAGE_INDEX",
  SET_PAGE_SIZE: "reducer/SET_PAGE_SIZE",
  GET_MODEL: "reducer/GET_MODEL",
  IS_LOADING: "reducer/LOADING_TRUE",
};

export const sagaTypes = {
  GET_ALL_MODELS: "saga/GET_ALL_MODELS",
  GET_MORE_MODELS: "saga/GET_MORE_MODELS",
  GET_MODEL: "saga/GET_MODEL",
};
